module.exports = __webpack_public_path__ + "static/media/msl3.c62ee677.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/msl3.jpg
// module id = 89
// module chunks = 0